export const locationTypes = [
  'store',
  'warehouse',
  'vwarehouse',
  'ecommerce',
  'plant',
  'supplier',
  'outlet',
  'unknown',
  'client',
];
